module.exports = __webpack_public_path__ + "img/refill-gas.7fd5bf9b.svg";